// ================================
// global consts
// ================================

export const API_TOKEN = '41rakznlmnggpw9ohu88b3hz13hd1scy'

/** global */
export const START_FETCH = 'START_FETCH'
export const END_FETCH = 'END_FETCH'

/** user */
export const LOGIN = 'LOGIN'
export const LOGIN_OUT = 'LOGIN_OUT'
export const SET_ACCESS = 'SET_ACCESS'



// WEBPACK FOOTER //
// ./src/consts/index.js